/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Link as LinkReact } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import useOrdenesPago from "../../hooks/useOrdenesPago";
import useLogin from "../../hooks/useLogin";
import DataTable from "../../components/DataTable/DataTable";
import Title from "../../components/Form/Title";
import { formatCurrency } from "../../utils/formato";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";

const COLUMNAS = [
  { field: "nombre", title: "Proyecto" },
  { field: "proveedor", title: "Proveedor" },
  { field: "cuenta_presupuental", title: "Cuenta Presupuestal" },
  { field: "cuantos_pagos", title: "Cuantos pagos" },
  {
    field: "montos",
    title: "Monto",
    align: "center",
    sortValue: (orden) => Number(orden.montos) || 0,
    render: (orden) => formatCurrency(orden.montos),
  },
  {
    field: "acciones",
    title: "Ordenes",
    sortable: false,
    filterable: false,
    align: "center",
    render: (orden) => (
      <LinkReact
        to={`/fechas-pago/${orden.proveedores_id}`}
        className="btn btn-warning btn-sm"
      >
        Ver Ordenes
      </LinkReact>
    ),
  },
];

export default function Index() {
  const { token, cliente_id } = useLogin();
  const dispatch = useDispatch();
  const { loading, message, success, Ordenes, OrdenesPagoGetService } = useOrdenesPago();

  useEffect(() => {
    dispatch(setTitle("Descargando Ordenes de pago"));
    dispatch(showLoader());
    OrdenesPagoGetService(cliente_id, token);
  }, []);

  useEffect(() => {
    if (Ordenes.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
  }, [Ordenes]);

  useEffect(() => {
    if (success === true) {
      OrdenesPagoGetService(cliente_id, token);
    }
  }, [OrdenesPagoGetService, success]);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  return (
    <div className="container">
      <div className="crud-header">
        <Title title="Ordenes de pago" className="crud-title" />
      </div>
      <div className="crud-card">
        <DataTable tableKey="ordenes-pago" loading={loading} columns={COLUMNAS} data={Ordenes} />
      </div>
    </div>
  );
}
